export default __webpack_public_path__ + "static/22-67d4d89607e1837a7e4db28dfa8cb0ce.webp";